import request from '@/utils/request';

export function queryShopOrderList(query) {
  return request({
    url: '/api/system/shopOrder/queryShopOrderList',
    method: 'post',
    data: query
  });
}
export function saveShopOrder(form) {
  return request({
    url: '/api/system/shopOrder/saveShopOrder',
    method: 'post',
    data: form
  });
}

//售后订单
export function deleteShopOrder(form) {
  return request({
    url: '/api/system/shopOrder/deleteShopOrder',
    method: 'post',
    data: form
  });
}

//售后订单
export function queryShopProblemList(form) {
  return request({
    url: '/api/system/shopProblem/queryShopProblemList',
    method: 'post',
    data: form
  });
}
//售后订单详情
export function getShopProblem(form) {
  return request({
    url: '/api/system/shopProblem/getShopProblem',
    method: 'post',
    data: form
  });
}
//微信支付

export function wxPayServiceFee(form) {
  return request({
    url: '/api/system/wxPayServiceFee/wxPayServiceFee',
    method: 'post',
    data: form
  });
}
//查询订单与商品信息

export function getOrderAndProduct(form) {
  return request({
    url: '/api/system/shopOrder/getOrderAndProducts',
    method: 'post',
    data: form
  });
}

export function getOrderAndProductPage(form) {
  return request({
    url: '/api/system/shopOrder/getOrderAndProductPage',
    method: 'post',
    data: form
  });
}

// 查询物流
export function queryOrderLogistics(form) {
  return request({
    url: '/api/system/shopOrder/queryOrderLogistics',
    method: 'post',
    data: form
  });
}

//触发订单状态
export function queryorder(form) {
  return request({
    url: '/api/system/wxPayServiceFee/queryorder',
    method: 'post',
    data: form
  });
}

//对公账户
export function queryShopCorporateAccountList(form) {
  return request({
    url: '/api/system/shopCorporateAccount/queryShopCorporateAccountList',
    method: 'post',
    data: form
  });
}

//获取返利数据
export function querySysRebateList(form) {
  return request({
    url: '/api/system/sysRebate/querySysRebateList',
    method: 'post',
    data: form
  });
}

//确认收货
export function confirmReceipt(form) {
  return request({
    url: '/api/system/shopOrder/confirmReceipt',
    method: 'post',
    data: form
  });
}

//根据购物车信息生成订单
export function generateOrder(form) {
  return request({
    url: '/api/system/shopOrder/generateOrder',
    method: 'post',
    data: form
  });
}

//根据商品信息生成订单
export function generateBuyOrder(form) {
  return request({
    url: '/api/system/shopOrder/generateBuyOrder',
    method: 'post',
    data: form
  });
}
//查询订单详情
export function getOrderDetail(form) {
  return request({
    url: '/api/system/shopOrder/getOrderDetail',
    method: 'post',
    data: form
  });
}

//逻辑删除退款订单
export function delShopProblem(form) {
  return request({
    url: '/api/system/shopProblem/delShopProblem',
    method: 'post',
    data: form
  });
}
//逻辑删除订单
export function delShopOrder(form) {
  return request({
    url: '/api/system/shopOrder/delShopOrder',
    method: 'post',
    data: form
  });
}



// WEBPACK FOOTER //
// ./src/api/order/index.js